import request from '@/utils/request';

// 标签人数
export function getQueryTagMember(values) {
  return request('/profile/tag/queryTagMember', {
    method: 'POST',
    data: values,
  });
}
// 收藏列表
export function getQueryFavorite(values) {
  return request('/profile/tag/queryFavorite', {
    method: 'POST',
    data: values,
  });
}
// 树形
export function getQueryTagTree(values) {
  return request('/profile/tag/queryTagTree', {
    method: 'POST',
    data: values,
  });
}
// 计算状态
export function updateComputeStatus(values) {
  return request('/profile/tag/updateComputeStatus', {
    method: 'POST',
    data: values,
  });
}
// 标签停用启用按钮
export function updateStatus(values) {
  return request('/profile/tag/updateStatus', {
    method: 'POST',
    data: values,
  });
}
// 收藏按钮
export function handleFavorite(values) {
  return request('/profile/tag/favorite', {
    method: 'POST',
    data: values,
  });
}
// 标签历史
export function getQueryTagHistory(values) {
  return request('/profile/tag/queryTagHistory', {
    method: 'POST',
    data: values,
  });
}
// 标签的下载按钮
export function getDownloadTagMember(values) {
  return request('/profile/tag/downloadTagMember', {
    method: 'POST',
    data: values,
  });
}
// 查询单个标签基本信息
export function getQueryTagInfo(values) {
  return request('/profile/tag/queryTagInfo', {
    method: 'POST',
    data: values,
  });
}

// 字段列表
export function getQueryFileList(values) {
  return request('/profile/file/queryFileList', {
    method: 'POST',
    data: values,
  });
}
// 新增集合标签
export function postInsertOrUpdateTagAndCollectionAndRule(values) {
  return request('/profile/tag/insertOrUpdateTagAndCollectionAndRule', {
    method: 'POST',
    data: values,
  });
}
// 集合标签详情
export function getQueryCollectionTagInfo(values) {
  return request('/profile/tag/queryCollectionTagInfo', {
    method: 'POST',
    data: values,
  });
}

// 标签规则操作框的维度表数据
export function getQueryTagOperatorValue(values) {
  return request('/profile/tag/rule/queryTagOperatorValue', {
    method: 'POST',
    data: values,
  });
}

// 标签目录的修改和新增
export function postInsertOrUpdate(values) {
  return request('/profile/tag/insertOrUpdateTagCatalogue', {
    method: 'POST',
    data: values,
  });
}

// 标签目录的删除
export function postDeleteTagCatalogue(values) {
  return request('/profile/tag/deleteTagCatalogue', {
    method: 'POST',
    data: values,
  });
}

// 删除标签
export function deleteLabel(values) {
  return request('/profile/tag/deleteTag', {
    method: 'POST',
    data: values,
  });
}
